<div class="container-fluid">
    <div class="page-title p-1">
      <div class="row">
        <div class="col-12">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!boxOpen" class="container-fluid">
    <div class="row align-items-centerpt-5 pb-5">
      <div class="col-md-12">
        <mat-card class="card-rack"><mat-grid-list cols="1" rowHeight="2:1">
            <mat-grid-tile>
              <img mat-card-xl-image src="./../../../../assets/images/start.png">
              <mat-list class="text-center">
                <mat-list-item>
                  <h4 class="text-center">Para comenzar,</h4>
                </mat-list-item>
                <mat-list-item>
                  <h4 class="text-center">escanea el código de la caja.</h4>
                </mat-list-item>
              </mat-list>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
    </div>
  </div>  
  
  <div [hidden]="!boxOpen" class="container-fluid">
    <div class="row">
      <div [ngClass]="box_readonly?'col-md-12':'col-md-8'">
        <mat-card class="card-rack">
          <mat-card-header class="full-width">
            <mat-card-title class="d-flex justify-content-between align-items-center full-width">
  
                <div class="d-flex align-items-center col-6">
                  <mat-icon class="me-2">checklist</mat-icon>
                  <span class="fw-bold">Lista de verificación</span>
                  <span class="ms-3 badge bg-light">
                    <mat-icon class="me-1 txt-primary">inventory_2</mat-icon>
                    <strong class="txt-dark" style="vertical-align: super;">{{ box_id_title }}</strong>
                  </span>
                </div>
                <div class="col-6 d-flex align-items-center justify-content-end">
                  <button mat-button class="button-md" (click)="allAutoScan(box_id_title)" *ngIf="!isBoxCompleted">
                    <mat-icon class="me-1 txt-primary">inventory_2</mat-icon>
                    Completar caja
                  </button>
                </div>
  
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table mat-table [dataSource]="listMaterials" class="mat-elevation-z8">
                <ng-container matColumnDef="validated">
                <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element" class="fw-bold txt-light p-1 "> 
                <div class="d-flex align-items-center">
                  <button mat-button [ngClass]="{'bg-warning' : element.verified, 'bg-info' : !element.verified }" class="txt-light me-2 ms-2" (click)="verifyProduct($event, element)">Validar</button>
                  <mat-icon [hidden]="!element.validated">check_circle</mat-icon> 
                </div>   
              </td>
                </ng-container>
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> Position </th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light p-1"> {{element.position}} </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light"> {{element.nombre}} </td>
              </ng-container>
              <ng-container matColumnDef="sku">
                <th mat-header-cell *matHeaderCellDef> SKU </th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light"> {{element.sku}} </td>
              </ng-container>
              <ng-container matColumnDef="pick">
                <th mat-header-cell *matHeaderCellDef> Hecho </th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light"> {{element.pick}} /
                  {{element.cantidad}} </td>
              </ng-container>
              <ng-container matColumnDef="faltante">
                <th mat-header-cell *matHeaderCellDef>Semáforo</th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light">
                  <span [hidden]="element.faltante!=2" class="badge badge-danger">Faltante</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="error">
                <th mat-header-cell *matHeaderCellDef>Error</th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light">
                  <span class="badge"
                    [ngClass]="{'badge-success-dark': element.resolved === 'Resuelto', 'badge-danger': element.resolved === 'No Resuelto'}">{{element.error}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="autoScan">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" class="h6 fw-bold txt-light" style="text-align: right;">
                  <button mat-button class="bg-success txt-light me-2" style="margin-left: 1rem;"
                    (click)="realizarAutoScan(element, $event)"
                    *ngIf="!isBoxCompleted && !(element.complete || element.pick === element.cantidad) || (element.pick_omit !== 0 && element.pick_omit)">
                    Escanear
                  </button>
                  <button *ngIf="element.imgs && element.imgs.length > 0" mat-button class="img" (click)="openImageModal(element,$event)" style="    background: white;
                              color: gray;
                              padding: 17px;">
                    Imagen
                  </button>
  
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row (click)="openDialogError(row)" *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="(next_scan&&row.id===next_scan.id) ? 'bg-info' : (row.complete||row.pick===row.cantidad)&&(row.pick_omit===0||!row.pick_omit) ? 'bg-success' : (row?.pick_omit>0) ? 'bg-warning' : 'bg-light-info'">
              </tr>
              <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="row.pick===row.cantidad ? 'bg-success' : (row.faltante==2?(row.id===next_scan.id ? 'bg-primary' : ( row.pick_omit>0 ? 'bg-warning' : 'bg-primary opacity-75')):(row.id===next_scan.id ? 'bg-info' : ( row.pick_omit>0 ? 'bg-warning' : 'bg-info opacity-50')))"></tr> -->
  
            </table>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-4" [hidden]="box_readonly">
        <mat-card class="card-rack">
          <mat-card-header>
            <mat-card-title>
              <h5 class="fw-bold"><mat-icon class="align-middle">videocam</mat-icon> Vista de video</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div style="text-align:center; position: fixed; width: 440px;">
              <video class="video" #video autoplay controls capture="camera" class="w-100"></video>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  
  <div *ngIf="boxOpen" class="container-fluid pt-3">
    <div class="row">
      <div class="col-md-12">
        <mat-card class="card-rack col-md-12">
          <mat-card-content>
            <div class="row">
              <div class="col-11">
                <label *ngFor="let st of line_status; let s = index" class="px-3 py-2 text-capitalize rounded me-2"
                  [ngClass]="{'bg-success' : st.status===1, 'bg-info' : st.status===0, 'bg-warning' : st.status===2 }"> {{
                  st.nombre }} </label>
              </div>
              <div class="col-1">
                <button mat-button class="button-md" (click)="allAutoScan(box_id_title)" *ngIf="!isBoxCompleted && userObj.tipo==='q'">
                  <mat-icon class="me-1 txt-primary">inventory_2</mat-icon>
                  Completar caja
                </button>
            </div>
          </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  